import { render, staticRenderFns } from "./PemakaianLaporanUmpd.vue?vue&type=template&id=6c300dd0&"
import script from "./PemakaianLaporanUmpd.vue?vue&type=script&lang=js&"
export * from "./PemakaianLaporanUmpd.vue?vue&type=script&lang=js&"
import style0 from "./PemakaianLaporanUmpd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports